<mat-card
  class="mb-25 tagus-card ratingsBox"
  [class.component-rtl-enabled]="themeService.isRTLEnabled()"
>
  <mat-card-content>
    <div class="d-md-flex align-items-center justify-content-space-between">
      <div class="content">
        <h5>Profissionais</h5>
        <span class="year muted-color">Ano de 2023</span>
        <h3>0 <span class="muted-color">Review</span></h3>
        <p>
          <i class="flaticon-star"></i> 0
          <span class="main-color">+0%</span> Profissionais cadastrados
        </p>
      </div>
      <div id="ratingschart">
        <apx-chart
          [series]="chartOptions.series!"
          [chart]="chartOptions.chart!"
          [labels]="chartOptions.labels!"
          [title]="chartOptions.title!"
          [theme]="chartOptions.theme!"
          [fill]="chartOptions.fill!"
          [yaxis]="chartOptions.yaxis!"
          [stroke]="chartOptions.stroke!"
          [legend]="chartOptions.legend!"
          [plotOptions]="chartOptions.plotOptions!"
        ></apx-chart>
      </div>
    </div>
  </mat-card-content>
</mat-card>
